import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import DoneRoundedIcon from '@material-ui/icons/DoneRounded'
import ClearRoundedIcon from '@material-ui/icons/ClearRounded'
import moment from 'utils/momentInstanse'

import { useShallowEqualSelector } from 'custom-hooks'
import {
  getIsFetchingAlertsSelector,
  deleteAlert,
  changeStatusAlert,
} from 'redux/reducers/alerts'
import { openConfirmationModal } from 'redux/reducers/confirmationModal'
import IconButton from 'components/CommonUI/IconButton/IconButton'
import Table from 'components/CommonUI/Table'
import { hex } from 'utils/hex'
import { statusValueConstants } from '../AlertContainer'

const AlertsTable = ({ data }) => {
  const isFetching = useShallowEqualSelector(getIsFetchingAlertsSelector)
  return (
    <div className="alerts_table_container">
      <Table
        data={data}
        classNameBodyRow="alerts_table_body_row"
        isClickRow
        defaultSortField="dateUpdated"
        defaultSortDirection={'desc'}
        isLoading={isFetching}
      >
        <Table.Column
          dataField="issue"
          caption="ALERT INFO"
          width={'50%'}
          cellRender={(props) => <AlertInfoCell {...props} />}
        />
        <Table.Column
          dataField="facility"
          caption="FACILITY"
          width={'15%'}
          classNameBodyCell="table_cell"
        />
        <Table.Column
          dataField="panel"
          caption="PANEL"
          classNameBodyCell="table_cell"
        />
        <Table.Column
          dataField="status"
          caption="STATUS"
          isSort
          cellRender={(props) => <StatusCell {...props} />}
        />
        <Table.Column
          dataField="dateUpdated"
          caption="LAST DETECTED / CREATED"
          align="right"
          classNameBodyCell="table_cell"
          width={'15%'}
          cellRender={(props) => <CreateCell {...props} />}
          isSort
        />
      </Table>
    </div>
  )
}

const AlertInfoCell = memo(({ data }) => {
  const { issue, issueDeviceType, created, assignee } = data
  return (
    <div className="alert_info_cell_container">
      <span className="issue_text">{issue}</span>
      <span className="rest_issue_info_wrap">
        <span className="issue_device_type_container">
          {issueDeviceType} issue
          {created && (
            <span className="issue_create_section">
              <span className="point">&#8226;</span>
              <span>
                Created by <span className="black">{created}</span>
              </span>
            </span>
          )}
          {assignee && (
            <span className="issue_create_section">
              <span className="point">&#8226;</span>
              <span>
                <span className="black">Assignee {assignee}</span>
              </span>
            </span>
          )}
        </span>
      </span>
    </div>
  )
})

const StatusCell = memo(({ data }) => {
  const { status } = data
  const color = status === statusValueConstants.RESOLVE ? '#4AA652' : '#D40C20'

  const text = status === statusValueConstants.RESOLVE ? 'Resolved' : 'Open'

  return (
    <span
      className="status_text"
      style={{
        color,
        backgroundColor: hex(color),
      }}
    >
      {text}
    </span>
  )
})

const CreateCell = memo(({ data }) => {
  const { dateCreated, dateUpdated, isRowFocused, status, id } = data
  const dispatch = useDispatch()

  const isStatusResolved = status === statusValueConstants.RESOLVE

  const _deleteAlert = (alertId) => {
    dispatch(deleteAlert(alertId))
  }

  const deleteAlertConfirm = (event) => {
    event.stopPropagation()
    dispatch(
      openConfirmationModal({
        modalData: {
          title: 'Are you sure you want to delete Alert? ',
          //description: 'Alert delete,',
          leftButtonTitle: 'Delete',
        },
        cb: _deleteAlert,
        arg: id,
      })
    )
  }

  ///"status": "Resolved" | "Open",

  const handleChangeStatusAlert = () => {
    dispatch(
      changeStatusAlert({
        id,
        status: isStatusResolved
          ? statusValueConstants.OPEN
          : statusValueConstants.RESOLVE,
      })
    )
  }

  const _dateUpdated = moment.unix(dateUpdated).format('MMM D [at] HH:mm')
  const _dateCreated = moment.unix(dateCreated).format('MMM D [at] HH:mm')

  if (isRowFocused) {
    return (
      <div className="cell_buttons_container">
        <IconButton
          className="cell_button delete"
          tooltipTitle="Delete alert"
          onClick={deleteAlertConfirm}
        >
          <DeleteForeverIcon />
        </IconButton>
        <IconButton
          className="cell_button delete"
          tooltipTitle={isStatusResolved ? 'Open' : 'Resolved'}
          onClick={handleChangeStatusAlert}
        >
          {isStatusResolved ? <ClearRoundedIcon /> : <DoneRoundedIcon />}
        </IconButton>
      </div>
    )
  }

  return (
      <div>
          <span className="status_text">{_dateUpdated}</span>
          <span className="status_text">{_dateCreated}</span>
      </div>
  )
})

export default AlertsTable
